export default class CacheConstants {
    public static readonly EXISTING_CONNECTIONS = 'existing-connections'
    public static readonly PROSPECTIVE_CONNECTIONS = 'prospective-connections'
    public static readonly ORGANIZATIONS = 'organizations'
    public static readonly EVENTS = 'events'
    public static readonly DEALS = 'deals'
}
